exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".questionnaire-subhead[data-v-18470f29]{padding:.1rem 1rem;font-size:1.2rem;border:1px solid #000;background-color:#ffffc1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-18470f29&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/page/subPages/Order/Cart.vue
// module id = 483
// module chunks = 0